import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ documentTemplateId = '' }) => {
  return await dponetAPI.get(`/document_categories/${documentTemplateId}`)
}

export default {
  get,
}
